<template>
  <div class="relative w-full h-auto mt-12 bg-lavender-blush-50 py-10">
    <div class="container mx-auto px-5">
      <h1
        class="flex items-center justify-center w-full font-extrabold text-3xl lg:text-4xl leading-9 mb-10"
      >
        Scopri cosa dicono di noi i nostri clienti Prénatal Lover
      </h1>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 w-full">
        <div
          v-for="(item, index) in reviews"
          :key="index"
          class="p-4"
          :class="[
            index === 0 ? 'md:col-start-1 md:col-end-2 md:row-start-1 md:row-end-3' : '',
            index === 1 ? 'md:col-start-2 md:col-end-3 md:row-start-1 md:row-end-2' : '',
            index === 2 ? 'md:col-start-2 md:col-end-3 md:row-start-2 md:row-end-3' : '',
          ]"
        >
          <div
            class="bg-white rounded-sm shadow-lg p-12 h-full flex flex-col justify-between"
          >
            <div class="text-[#828282] text-sm mb-4">
              {{ item.review }}
            </div>
            <div class="flex justify-between gap-3">
              <div>
                <div class="font-bold text-black">{{ item.name }}</div>
              </div>
              <div>
                <nuxt-img
                  src="/images/aphostrophe.png"
                  class="w-10 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

const reviews = [
  {
    review: `Tutto perfetto.
  Non ho mai riscontrato difetti, problemi … 
  La qualità è eccellente, la maggior parte delle volte si trovano tantissime offerte sia sul vestiario che su altre categorie… 
  In più c’è il nuovo programma fedeltà Prénatal lover! 
  Consiglio al 100% I negozi PRENATAL  `,

    name: "Annalisa ",
  },
  {
    review: `Tempi di consegna veloce e programma fedeltà molto conveniente `,

    name: "Federica",
  },
  {
    review: `Prezzi molto buoni,specie con la carta fedeltà!prodotti di qualità e molte promozioni! `,

    name: "Luca F. ",
  },
];
</script>
